import { createFileRoute } from "@tanstack/react-router";
import { AngebotVorschau } from "@/pages/team/AngebotVorschau";

/**
 * „Vorschau wie beim Kunden" (13.09.2026) — dieselbe Seite wie /angebot/:token,
 * aber hinter der Anmeldung über die Angebots-Id. Das `$angebotId_` mit
 * Unterstrich hält sie aus dem Editor heraus (der hat kein Outlet).
 */
export const Route = createFileRoute(
	"/_angemeldet/_mitarbeiter/anfragen/$id_/angebote/$angebotId_/vorschau",
)({
	component: AngebotVorschauSeite,
});

function AngebotVorschauSeite() {
	const { id, angebotId } = Route.useParams();
	return <AngebotVorschau id={id} angebotId={angebotId} />;
}
